export default __webpack_public_path__ + "static/media/horn.06eaaa4a.png";